import { getDataAttr, forEach } from "@olmokit/dom";
import { globalData, globalConf } from "@olmokit/core/data";
import { getUrlQueryParams } from "@olmokit/utils/getUrlQueryParams";
import dialogProduct from "components/Dialog/Product";
import { dataLayerAddToCart } from "components/Datalayer"
import "components/Mosaic";
import "components/Trim";
import "./index.scss";
import "./mosaics.scss";
import "./sizes.scss";


const ATTR_COLLECTION_SLUG = "collection-slug";
const ATTR_PRODUCT_SLUG = "product-slug";

/**
 * Handle click on products via event delegation, it is faster here to have
 * a single listener. Prevent default events, so links are not followed.
 *
 * @param {Event} event
 */
export function handleProductOpen(event) {
  const $productLink = event.target.closest(`[data-${ATTR_PRODUCT_SLUG}]`);

  if ($productLink) {
    event.preventDefault();
    const product = getDataAttr($productLink, ATTR_PRODUCT_SLUG);
    const collection = getDataAttr($productLink, ATTR_COLLECTION_SLUG);

    let selectedProduct = globalData.collection.product.find((prod) => product == prod.slug)
    let selectedCategory = globalData.collection.property.find((prod) => 'Category' == prod.parent.name)
    let selectedLook = globalData.collection.property.find((prod) => 'Look' == prod.parent.name)

    //:Aggiungere index
    dataLayerAddToCart(
      selectedProduct.name,
      selectedCategory.name,
      selectedLook.name,
      selectedProduct.simplename,
      0
    );

    navigateToProduct(collection, product);
    dialogProduct.goto(product);
  }
}

/**
 * Navigate to product
 *
 * @param {string} collection
 * @param {string} product
 */
export function navigateToProduct(collection, product) {
  // const parts = getUrlQueryParams();
  const parts = getPathnameParts();
  const newPathname = [
    parts[0], // locale
    // parts[1], collection not needed
    collection,
    product,
  ].join("/");

  // setProductSEO(product);

  changeUrlPath(newPathname, { collection, product }, true);
}

/**
 * Navigate back to collection by reading the current URL pathname
 */
export function navigateBackToCollection() {
  const parts = getPathnameParts();
  const newPathname = [
    parts[0], // porcelain-tile-collections
    parts[1], // collection
    // parts[2], // product
  ].join("/");

  // setCollectionSEO();

  changeUrlPath(newPathname, undefined, true);
}

/**
 * Handle pop state history event
 *
 * @param {PopStateEvent} event
 */
export function handlePopState({ state }) {
  if (!state) {
    dialogProduct.goaway();
    // setCollectionSEO();
    // } else if (state && state.collection && state.product) {
    //   dialogProduct.goto(state.product);
    //   setProductSEO(state.product);
  }
}

/**
 * Set SEO data for current collection
 */
function setCollectionSEO() {
  setSEO(globalData.seo.collection);
}

/**
 * Set SEO data for given product
 *
 * @param {string} productSlug
 */
function setProductSEO(productSlug) {
  setSEO(globalData.seo.products[productSlug]);
}

/**
 * Set SEO data, for now it just swaps the document title
 * @param {Object} data SEO's JSON data exposed on global page's window
 */
function setSEO(data) {
  document.title = data["meta_title"];
}

export function getPathnameParts() {
  const currentLocation = location;
  const pathnameCleaned = currentLocation.pathname.replace(/^\//, "");
  return pathnameCleaned.split("/");
}

export function changeUrlPath(
  pathname: string,
  state?: object,
  replace?: boolean
) {
  const path = normaliseUrlPath(`/${pathname}/`);
  console.log('path', path);

  history[replace ? "replaceState" : "pushState"](state, null, path);

  return path;
}

export function normaliseUrlPath(path: string) {
  return path.replace(/\/+/g, "/");
}